module.exports = __webpack_public_path__ + "img/compact-disc.2b156813.svg";